import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { CreditService } from '../credit.service';
import { NotificationService } from 'app/core/services/notification.service';
import { SessionService } from 'app/core/services/session.service';
import { ProfileService } from 'app/core/components/profile/profile.service';
import { CreditCommonService } from '../../common/services/credit-common.service';
import { RxComponent } from 'app/core/components/common/rx.component';

@Component({
	selector: 'itpx-reject',
	templateUrl: './reject.component.html',
	styleUrls: ['./reject.component.css']
})
export class RejectComponent extends RxComponent implements OnInit {

	private optionsDecision: any;
	private userDetails: any;

	rejectForm: FormGroup;
	constructor(
		private fb: FormBuilder,
		private modalService: SmartModalService,
		private service: CreditService,
		private notificationService: NotificationService,
		private sessionService: SessionService,
		private profileService: ProfileService,
		private creditCommonService: CreditCommonService
	) {
		super();
	}

	ngOnInit() {
		this.rejectForm = this.fb.group({
			message: ['', Validators.required]
		})

		this.profileService.getProfile()
			.subscribe(
				body => this.userDetails = body['data']
			);
	}

	private onCancel() {
		this.modalService.close();
	}
	private onSubmit() {
		let details = this['data'];
		details['creditDecision'] = {
			userName: this.userDetails.name,
			userEmail: this.userDetails.username,
			message: this.rejectForm.controls.message.value,
		}
		this.service.rejectCreditApplication(details)
            .subscribe(
                data => {
                    this.notificationService.success('The credit application has been rejected',
                    'Success');
					this.modalService.sendResult('success');
					this.sendEmail(details);
                },
                error => {
                    this.onCancel();
                }
            )
	}
	private sendEmail(details: any) {
		let emailDetails = {
			emailTemplate: 'credit-application-rejected',
			to: details.userEmail,
			extra: {
				message: this.rejectForm.controls.message.value,
				name: details.userName
			}
		}

		this.creditCommonService.sendEmail(emailDetails)
			.subscribe(
				data => {},
				error => {}
			)
	}
	

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/credit/reject/reject.component.ts